import { combineReducers } from 'redux'

import { reducer as router } from './modules/router'
import { reducer as snackbar } from './modules/snackbar'
import { reducer as network } from './modules/network'
import { reducer as project } from './modules/project'
import { reducer as user } from './modules/user'

const reducers = {
  router,
  snackbar,
  network,
  project,
  user,
}

export default combineReducers(reducers)
